import { render, staticRenderFns } from "./custom_post_lists.vue?vue&type=template&id=e567df1c&"
import script from "./custom_post_lists.vue?vue&type=script&lang=js&"
export * from "./custom_post_lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports